/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const getIsImmersiveMode = stores => stores.appUiState.isImmersiveMode;
export const shouldRenderPageShadows = stores => stores.appUiState.shouldRenderPageShadows;
export const getScrollbarSize = stores => stores.appUiState.scrollbarSize;
export const getAdressBarHeight = stores => stores.appUiState.addressBarHeight;
export const getAppContext = stores => stores.appUiState.appContext;
